// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_9BVHY","btn":"index_btn_1d6de"};